import LiveTVBadge from './LiveTVBadge'

export default LiveTVBadge
